import { HttpResponse, HttpRequestConfig } from '@/utils/http-utils';
import siteConfigService from '@/services/site.config.service';
import httpService from '@/services/http.service';
import storageServices from '@/services/storage.service';
import Organization from '@/entities/organization';
import Logger from '@/utils/logger.utils';
import { CacheConfig } from '@/entities/cache';
import OrgSelectedEventPayload from '@/events/entities/org.selected';
import JSONUtils from '@/utils/json-utils';
import { browserService, UserInfoContext, userService } from '@ol/ol-ui-core';


class OrganizationsFromAPI {
  ssoToken?: string;
  organizations?: any;
  Organizations?: any;
}


class OrganizationService {
  private cacheName: string = 'UserOrg';
  public async getOrganizationList(): Promise<Array<Organization>> {
    const orgListApi: any = await siteConfigService.getApiEndpoint('organization.orgList');
    const plId: number = await storageServices.getPrivateLabelId();
    const ssoToken: string = await userService.getSsoToken(plId);
    const orgListData: UserInfoContext = await userService.getUserInfoContext(plId, ssoToken);
    const userId: number = await userService.getUserId(plId, ssoToken);
    const languageCode = await browserService.getLanguageCode(plId);
    const cacheConfig: CacheConfig = {
      name: 'userOrganizationIdNameAndPlIds',
      key: `${plId}_${userId}_${languageCode}`,
      options: {
        forceUpdate: false,
        timeToLive: -1,
        secondLevel: true,
      },
    };
    const config: HttpRequestConfig = {
      cache: cacheConfig,
    };

    let orgListFromApi: OrganizationsFromAPI = new OrganizationsFromAPI();

    if (orgListApi) {
      const orgListFromApiRes: HttpResponse<OrganizationsFromAPI> = await httpService.get<OrganizationsFromAPI>(orgListApi, config);
      orgListFromApi = orgListFromApiRes.data;
    }

    const organizations: any = JSONUtils.parse(orgListFromApi.organizations || orgListData.Organizations);
    let orgList: Array<Organization> = new Array<Organization>();
    let org: any = new Organization();
    if (!Array.isArray(organizations)) {
      try {
        org = Object.assign(org, organizations);
        orgList.push(org);
      } catch (e) {
        Logger.info(e.toString());
      }
    } else {
      orgList = organizations as Array<Organization>;
      orgList.sort((a: any, b: any) => a.name.localeCompare(b.name));
    }

    return orgList;
  }

  private orgSelectItemValueDelimeter: string = '_';
  public async getOrgSelectedPayload(event: any, defaultPlId: number): Promise<OrgSelectedEventPayload> {
    const orgIdPossibleWithPlId: string = event.currentTarget.value;
    const plIdOrgId: Array<String> = orgIdPossibleWithPlId.split(this.orgSelectItemValueDelimeter);
    let orgId: number = null;
    let plId: number = null;
    if (!!plIdOrgId && plIdOrgId.length === 2) {
      plId = Number.parseInt(plIdOrgId[0].toString(), 10);
      orgId = Number.parseInt(plIdOrgId[1].toString(), 10);
    } else {
      plId = defaultPlId;
      orgId = Number.parseInt(plIdOrgId[0].toString(), 10);
    }
    return { plId, orgId, orgSelectItemId: orgIdPossibleWithPlId };
  }
}


// Export a singleton instance in the global namespace
export default new OrganizationService();
